/* Enverus land grid from the Mapbox Studio style. Toggles only borders and labels,
   the transparent sections fill stays on for the grid readout and draw snapping. */
const LAYER_ID = "landGrid";

const SOURCE_ID = "composite";
const SOURCE_LAYER = "enverus_grid_sections";
const SECTIONS_LAYER_ID = "Enverus grid sections";
const BORDER_HIGHLIGHT_LAYER_ID = "Enverus grid sections highlight";

const UNIQUE_COLUMN = "object_id";

const TOGGLE_LAYER_IDS = [
  "Enverus grid section border",
  "Enverus grid labels TX abstract",
  "Enverus grid labels TX survey",
  "Enverus grid labels PLSS",
];

const CLICKABLE_LAYERS = [SECTIONS_LAYER_ID];

const addAll = (mapRef) => {
  const map = mapRef.current;

  if (map.getLayer(BORDER_HIGHLIGHT_LAYER_ID) || !map.getSource(SOURCE_ID)) {
    return;
  }

  map.addLayer({
    id: BORDER_HIGHLIGHT_LAYER_ID,
    type: "line",
    source: SOURCE_ID,
    "source-layer": SOURCE_LAYER,
    paint: {
      "line-color": "#000",
      "line-width": 3,
    },
    filter: ["in", UNIQUE_COLUMN, ""],
  });
};

const setAnnotationVisibility = (action) => {
  const { mapRef, value } = action;

  if (!mapRef || !mapRef.current) return;

  const map = mapRef.current;
  const visibility = value ? "visible" : "none";

  TOGGLE_LAYER_IDS.forEach((layerId) => {
    if (map.getLayer(layerId)) {
      map.setLayoutProperty(layerId, "visibility", visibility);
    }
  });

  if (!value && map.getLayer(BORDER_HIGHLIGHT_LAYER_ID)) {
    map.setLayoutProperty(BORDER_HIGHLIGHT_LAYER_ID, "visibility", "none");
  }
};

export {
  LAYER_ID,
  BORDER_HIGHLIGHT_LAYER_ID,
  UNIQUE_COLUMN,
  CLICKABLE_LAYERS,
  addAll,
  setAnnotationVisibility,
};
